export const environment = {
  production: false,
  apiUrl: 'https://api.dev.sapptradingpro.com/api/v1',
  apiTestUrl: 'http://57.128.245.130:8083/api/v1',
  apiKeyFinnhub: 'd688tchr01qi2if77sr0d688tchr01qi2if77srg',
  fedapay: {
    publicKey: 'pk_sandbox_F-rXOZpKr8MW-jPY9fH2Nyoq',
    apiVersion: 'v1',
    environment: 'sandbox'
  }
};
